import React, { forwardRef } from "react"
import { Container, Asset1 } from './styled';

export interface AboutFullscreenAssetProps { className?: string, data: any };

const AboutFullscreenAsset = forwardRef((props: AboutFullscreenAssetProps, ref) => {

  return (
    <Container className={props.className}>
      <Asset1 autoplay={false} data={props.data.Asset1}></Asset1>
    </Container>
  )
})

export default AboutFullscreenAsset;
